import { h, defineComponent } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { namedLink } from '@/ui/components';
import { readOnlyField } from '@/ui/components/form/ReadOnlyField';

export interface IssueDetailsInspectionContentProps {
  inspectionId: string;
  inspectionTitle: string;
  pageTitle: string;
  sectionTitle: string;
  question: string;
  response: string;
}

export const IssueDetailsInspectionContent = defineComponent<IssueDetailsInspectionContentProps>({
  name: 'IssueDetailsInspectionContent',
  props: ['inspectionId', 'inspectionTitle', 'pageTitle', 'sectionTitle', 'question', 'response'],
  setup(props) {
    return function render() {
      const inspectionLink = h('div', { class: 'field field--semibold' }, [
        h('label', { class: 'label' }, t('inspections.title')),
        props.inspectionId && props.inspectionId !== '-'
          ? namedLink(
            props.inspectionTitle,
            'inspectionDetail',
            props.inspectionId.toString(),
          )
          : h('span', props.inspectionTitle),
      ]);

      return h('div', [
        inspectionLink,
        readOnlyField({
          name: 'inspectionPage',
          label: t('inspections.page'),
          value: props.pageTitle,
        }),
        readOnlyField({
          name: 'inspectionSection',
          label: t('inspections.section-label'),
          value: props.sectionTitle,
        }),
        readOnlyField({
          name: 'inspectionQuery',
          label: t('inspections.query'),
          value: props.question,
        }),
        readOnlyField({
          name: 'inspectionResponse',
          label: t('inspections.answer'),
          value: props.response,
        }),
      ]);
    };
  },
});
